import { PaymentType } from "../enum/paymentType.enum";

export interface PaymentGatewayModel {
    pgCode: string;
    systemCode: string;
    type: PaymentType;
    settings: PaymentSettings;
    description: string;
    descriptionExt?: string;
    image?: string;
    urlImage?: string;
    creado?: string;
    modificado?: string;
    fechaCreacion?: Date;
    fechaActualizacion?: Date;
    completeness?: any;
    status: string;
};

export interface PaymentSettings {
    url: string;
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/model/interfaces/paymentGateway.interface.ts